import { DataRequest } from '../interfaces';

export const DATA_REQUEST: Readonly<DataRequest<any>> = { pagination: { offset: 0, limit: 100 } };

export function getDataRequest(): DataRequest<any> {
  return JSON.parse(JSON.stringify(DATA_REQUEST));
}
